import {ActionIcon, Center, Container, Group, Header, Indicator, SimpleGrid} from "@mantine/core";
import Logo from "../../../assets/hubgo.svg?react";
import WaterGoLogo from "../../../assets/watergo.svg?react";
import OilGoLogo from "../../../assets/oilgo.svg?react";
import {useAppSelector} from "../../store/hooks/useAppSelector";
import {getAppCategory} from "../../store/ui/selectors";
import {NoticeDrawer, TransportCategoryMenu, useAuth, useChat} from "@ots-frontend/ots-ui";
import {setAppCategory} from "../../store/ui/actions";
import {useDispatch} from "react-redux";
import {NavHeaderIsland} from "../NavHeaderIsland/NavHeaderIsland";
import {
  getUseQueryResultData,
  NoticeBadgeSummary,
  transportCategory,
  useGetNoticeBadgeSummaryQuery
} from "@ots-frontend/ots-data";
import {useNavigate} from "react-router-dom";
import {useCallback, useMemo} from "react";
import {IconBell, IconMessageCircle} from "@tabler/icons-react";
import {skipToken} from "@reduxjs/toolkit/query";
import {createSelector} from "@reduxjs/toolkit";
import {useDisclosure} from "@mantine/hooks";

export type NavHeaderProps = {
  // props here
}

export const NavHeader = (props: NavHeaderProps) => {
  const appCategory = useAppSelector(getAppCategory);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const chat = useChat()
  const {hasAccess} = useAuth()

  const noticeDrawerDisclosure = useDisclosure(false);
  const noticeDrawerOpened = noticeDrawerDisclosure[0]
  const noticeDrawerHandlers = noticeDrawerDisclosure[1]

  const canViewNotices = hasAccess('notice_view')

  const selectNoticeBadgeSummary = useMemo(() => {
    return createSelector(
      [getUseQueryResultData<NoticeBadgeSummary>],
      (data) => {
        return data ?? {activeCount: 0}
      }
    )
  }, []);

  const {noticeBadgeSummary} = useGetNoticeBadgeSummaryQuery(canViewNotices ? undefined : skipToken, {
    selectFromResult: (result) => ({
      ...result,
      noticeBadgeSummary: selectNoticeBadgeSummary(result),
      isFetchingBadge: result.isFetching,
    })
  });

  const onChatButtonClick = useCallback(() => {
    navigate('/chat')
  }, [navigate])

  const onAlertButtonClick = useCallback(() => {
    if (canViewNotices) {
      noticeDrawerHandlers.open()
    }
  }, [noticeDrawerHandlers, canViewNotices])

  return (
    <>
      <Header height={60} p="xs">
        <Center h="100%" w="100%">
          <Group w="100%" px="md" position="apart">
            <SimpleGrid cols={3} h="100%" w="100%">
              <NavHeaderIsland/>
              <Container>
                <Group spacing="md">
                  <Logo height={30}/>
                  {appCategory === transportCategory.water &&
                    <>
                      /
                      <WaterGoLogo height={30}/>
                    </>
                  }
                  {appCategory === transportCategory.oil &&
                    <>
                      /
                      <OilGoLogo height={30}/>
                    </>
                  }
                </Group>
              </Container>

              <Group position="right">

                {chat.enabled &&
                  <Indicator
                    inline
                    label={chat.unread}
                    size={18}
                    color="red"
                    withBorder
                    offset={7}
                  >
                    <ActionIcon
                      size="lg"
                      variant="subtle"
                      onClick={onChatButtonClick}
                    >
                      <IconMessageCircle size={24} stroke={2}/>
                    </ActionIcon>
                  </Indicator>
                }

                {canViewNotices &&
                  <Indicator
                    inline
                    label={noticeBadgeSummary.activeCount}
                    size={18}
                    color="red"
                    withBorder
                    offset={7}
                  >
                    <ActionIcon
                      size="lg"
                      variant="subtle"
                      onClick={onAlertButtonClick}
                    >
                      <IconBell size={24} stroke={2}/>
                    </ActionIcon>
                  </Indicator>
                }

                <TransportCategoryMenu
                  shadow="md"
                  width={200}
                  category={appCategory}
                  onCategoryClick={(category) => dispatch(setAppCategory(category))}/>
              </Group>

            </SimpleGrid>
          </Group>
        </Center>
      </Header>

      <NoticeDrawer
        opened={noticeDrawerOpened}
        onClose={noticeDrawerHandlers.close}
        position="right"
        size="md"
        overlayProps={{blur: 2}}/>
    </>
  );
};
